import { CONTRACT_ACCOUNT, REDEEM_MEMO } from '../config/redeem';

/* Send selected NFTs to the contract for redemption.
   The contract credits a claimable reward and BURNS the NFTs. */
export async function sendNftsForRedemption(session, assetIds) {
  const action = {
    account: 'atomicassets',
    name: 'transfer',
    authorization: [session.permissionLevel],
    data: {
      from: session.actor,
      to: CONTRACT_ACCOUNT,
      asset_ids: assetIds.map(String),
      memo: REDEEM_MEMO,
    },
  };
  return session.transact({ actions: [action] });
}

/* Claim the caller's pending reward balance from the contract. */
export async function claimRewards(session) {
  const action = {
    account: CONTRACT_ACCOUNT,
    name: 'claim',
    authorization: [session.permissionLevel],
    data: { owner: session.actor },
  };
  return session.transact({ actions: [action] });
}
